<template>
    <div>
        <div class="col-lg-12 margin-tb">
            <div class="pull-left">
                <h2>{{ formTitle }}</h2>
            </div>
            <div class="pull-right">
                <router-link class="btn btn-edit" :to="{ name:'users'}">Back</router-link>
            </div>
        </div>
        <div class="col-md-6">
            <div class="col-xs-12 col-sm-12 col-md-12">
                <div class="form-group">
                    <strong>First Name:</strong>
                    <input type="text" v-model="firstName" placeholder="First name" class="form-control" />
                    <div v-if="submitted && !firstName" class="invalid-feedback d-block">First name is required</div>
                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12">
                <div class="form-group">
                    <strong>Last Name:</strong>
                    <input type="text" v-model="lastName" placeholder="Last name" class="form-control" />
                    <div v-if="submitted && !lastName" class="invalid-feedback">Last name is required</div>
                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12">
                <div class="form-group">
                    <strong>Company Name:</strong>
                    <input type="text" v-model="companyName" placeholder="Company name" class="form-control" />

                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12">
                <div class="form-group">
                    <strong>Username:</strong>
                    <input type="text" v-model="username" placeholder="Username" class="form-control" />
                    <div v-if="submitted && !username" class="invalid-feedback">Username is required</div>
                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12">
                <div class="form-group">
                    <strong>Email:</strong>
                    <input type="text" v-model="email" placeholder="Email" class="form-control" />
                    <div v-if="submitted && !email" class="invalid-feedback">Email is required</div>
                </div>
                <div class="form-group">
                    <label htmlFor="password">Password</label>
                    <input type="password" v-model="password" name="password" class="form-control" :class="{ 'is-invalid': submitted && !password }" />
                    <div v-if="submitted && !password && !id" class="invalid-feedback">Password is required</div>
                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12">
                <div class="form-group">
                    <strong>Role:</strong>
                    <select class="form-control" v-model="role">
                        <option value="Admin">Admin</option>
                        <option value="Management">Management</option>
                        <option value="Owner">Owner</option>
                    </select>
                    <div v-if="submitted && !role" class="invalid-feedback d-block">role is required</div>
                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12">
                <div class="form-group">
                    <strong>Number of buildings:</strong>
                    <input type="number" style="width:100%" v-model="numberOfBuildings" placeholder="Number of buildings" class="form-control" />
                    <label>Leave 0 for unlimited buildings</label>
                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12">
                <div class="form-group">
                    <strong>Is Active:</strong>
                    <input type="checkbox" v-model="isActive" />
                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12">
                <div class="form-group">
                    <strong>Price:</strong>
                    <input type="number" style="width:100%" v-model="price" placeholder="Price per unit" class="form-control" />
                  
                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12">
                <div class="form-group">
                    <strong>Commission:</strong>
                    <input type="number" style="width:100%" v-model="commission" placeholder="Commission per unit" class="form-control" />
                </div>
            </div>
            <input type="hidden" name="user_id" value="user_id" />
            <section id="complexes" style="display:none;">
            </section>
            <div class="col-xs-12 col-sm-12 col-md-12 text-center">
                <button type="submit" @click="submit()" class="btn btn-edit">Submit</button>
            </div>
        </div>
    </div>
</template>
<script>
    import { authenticationService } from "@/_services";
    import { Role } from "@/_helpers";
export default {
  data: function () {
    return {
      firstName: "",
      lastName: "",
      username: "",
      password: "",
        email: "",
        price: 0,
        commission:0,
        companyName: "",
        isActive: null,
      role: "Management",
      formTitle: "Add User",
      id: 0,
      numberOfBuildings: 0,
        submitted: false,
        currentUser: null
    };
        },
        created() {
            authenticationService.currentUser.subscribe((x) => (this.currentUser = x));
        },
        mounted() {
          
    if (this.$route.params.id) {
      this.formTitle = "Edit User";
      this.id = this.$route.params.id;
        this.getUser();
        
    }
  },
  methods: {
    getUser: function () {
      this.$http.get("/users/" + this.id).then((response) => {
        (this.firstName = response.data.firstName),
          (this.lastName = response.data.lastName),
          (this.username = response.data.username),
            (this.companyName = response.data.companyName),
            (this.email = response.data.email),
            (this.price = response.data.price),
            (this.commission = response.data.commission),
          (this.role = response.data.role),
          (this.numberOfBuildings = response.data.numberOfBuildings),
          (this.isActive = response.data.isActive);
        // this.post_code = response.data.postCode
      });
    },
    submit: function () {
      var canSubmit =
        this.firstName && this.lastName && this.username && this.email;
      if (!this.id) canSubmit = canSubmit && this.password;
      if (this.id) {
        this.submitted = true;
        if (canSubmit)
          this.$http
            .put("/users" , {
              id: this.id,
              firstName: this.firstName,
              lastName: this.lastName,
                username: this.username,
                price: this.price,
              commission:this.commission,
              email: this.email,
              password: this.password,
              role: this.role,
                numberOfBuildings: this.numberOfBuildings,
              companyName: this.companyName,
                isActive: this.isActive,
             })
            .then(
                () => {
                    console.log(this.currentUser)
                    if (this.currentUser && this.currentUser.role === Role.Owner)
          this.$router.push({ name: 'propertiesowner' })
          else
                this.$router.push("/management/users");
              },
              () => {
                alert("error");
                //  this.infoError = true
                //  this.loader = false
                this.password = "";
              }
            );
      } else {
        this.submitted = true;
        if (canSubmit)
          this.$http
            .post("/users/register", {
              firstName: this.firstName,
              lastName: this.lastName,
              username: this.username,
              email: this.email,
                password: this.password,
                price: this.price,
                commission: this.commission,
              role: this.role,
                numberOfBuildings: this.numberOfBuildings,
                companyName: this.companyName,
              isActive: this.isActive,
            })
            .then(
              () => {
                this.$router.push("/management/users");
              },
              () => {
                alert("error");
                //  this.infoError = true
                //  this.loader = false
                this.password = "";
              }
            );
      }
    },
  },
};
</script>